import React, { useState } from 'react'
import { showToast } from 'src/core/helpers'
import { useTranslation } from 'next-i18next'
import { PushNotification } from 'src/core/models'
import { Button, Popconfirm, Tooltip } from 'antd'
import { deleteNotificationAPI } from 'src/features'
import { DeleteOutlined, EditOutlined } from '@ant-design/icons'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import CreatePushNotificationForm
  from '../PushNotificationsListHeader/CreatePushNotificationForm/CreatePushNotificationForm'


const PushNotificationActionsColumn: React.FC<{ notification: PushNotification }> = ({ notification }) => {
  const { t } = useTranslation()
  const { id } = notification
  const queryClient = useQueryClient()
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false)
  let scheduledTimeDate
  if (typeof notification.scheduledTime === 'string') {
    scheduledTimeDate = new Date(notification.scheduledTime)
  } else {
    scheduledTimeDate = notification.scheduledTime.toDate()
  }
  const currentTime = new Date()
  const deleteNotificationMutation = useMutation(deleteNotificationAPI, {
    onSuccess: () => {
      showToast('success', t('Notification deleted successfully'), 3)
      // @ts-ignore
      queryClient.invalidateQueries('pushNotification')},
    onError: () => {
      showToast('error', t('Failed to delete notification'), 3)
    },
    onSettled: () => {
      // @ts-ignore
      queryClient.invalidateQueries('pushNotification')
    }
  })


  return <div className='centered'>
    <Tooltip title={'Edit'} color='blue' className='mr-2'>
      <Button
        type='ghost'
        shape='circle'
        icon={<EditOutlined />}
        disabled={scheduledTimeDate < currentTime}
        onClick={() => setIsModalVisible(true)}
      />
    </Tooltip>
    {/* Delete */}
    <Popconfirm
      okText={t('general.Yes')}
      cancelText={t('general.Cancel')}
      title={t('general.SureDelete')}
      placement={'left'}
      disabled={scheduledTimeDate < currentTime}
      onConfirm={() => deleteNotificationMutation.mutate(id)}
    >
      <Button
        danger
        type='ghost'
        size='middle'
        shape='circle'
        disabled={scheduledTimeDate < currentTime}
        icon={ <DeleteOutlined /> }
        className={`radius-100 ml-2`}
      />
    </Popconfirm>

    <CreatePushNotificationForm
      notification={notification}
      isModalVisible={isModalVisible}
      setIsModalVisible={() => setIsModalVisible(false)}

    />
  </div>
}

export default PushNotificationActionsColumn
